<template>
  <div class="p-4 sm:p-12">
    <div class="max-w-7xl p-4 sm:p-12 m-auto bg-white dark:bg-slate-800 rounded-lg outline outline-slate-200 dark:outline-slate-700">
      <main class="max-w-none prose prose-slate dark:prose-invert">
        <slot />
      </main>
    </div>
  </div>
</template>
